import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";

const useStyle = makeStyles((theme) => ({
  root: {},
  backButton: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "auto",
    height: "45px",
    boxShadow: "none",
    fontSize: "16px",
    marginRight: "auto",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      boxShadow: "none",
      transform: "none",
    },
  },
}));
interface ModuleOverviewHeaderProps {
  onBackClick: () => void;
  backButtonLabel: string;
  disableBack?: boolean;
  children?: React.ReactNode;
}
export const ModuleOverviewHeader = (props: ModuleOverviewHeaderProps) => {
  const classes = useStyle();
  const { children, onBackClick, backButtonLabel, disableBack = false } = props;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
      {!disableBack && (
        <Button
          size="medium"
          className={classes.backButton}
          variant="contained"
          sx={{
            marginLeft: "-0.85em",
            "&:active": {
              border: "2px solid #191919",
            },
          }}
          onClick={onBackClick}
          startIcon={<ArrowBackIcon style={{ width: "16px", height: "16px" }} />}>
          {backButtonLabel}
        </Button>
      )}
      {children}
    </Box>
  );
};
